import { render, staticRenderFns } from "./StatisticContainer.vue?vue&type=template&id=76d88790&scoped=true&"
import script from "./StatisticContainer.vue?vue&type=script&lang=ts&"
export * from "./StatisticContainer.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticContainer.vue?vue&type=style&index=0&id=76d88790&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d88790",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
